module.exports = __webpack_public_path__ + "static/Design-prototyping-An-introduction-3fa9f6c462f972437f928f84e4391095.png";